import { get } from '..';
import { applySolveAnalyticsFilters, GetSolveAnalyticsStatsProps } from './Utils';

const GetTimesOnTaskStats = (props: GetSolveAnalyticsStatsProps) => {
  const baseUrl: string = 'solve-analytics/tickets/times-on-task';
  const url: string = applySolveAnalyticsFilters(baseUrl, props);
  return get(url);
};

export default GetTimesOnTaskStats;
